import { ArrowRightIcon } from '@langchain/untitled-ui-icons';
import { Switch } from '@mui/joy';

import { Button, ButtonGroup, Tooltip } from '@/design-system';
import { cn } from '@/utils/tailwind';

import { DatasetSchema } from '../../types/schema';
import { ExperimentLanguage } from './types';

export const DetailPaneHeader = ({
  dataset,
  children,
  rowDetailLanguage,
  setRowDetailLanguage,
  setExampleDetailInSidePaneOpen,
  isShowingDiff,
  setIsShowingDiff,
}: {
  dataset?: DatasetSchema;
  children: React.ReactNode;
  rowDetailLanguage: ExperimentLanguage;
  setRowDetailLanguage: (language: ExperimentLanguage) => void;
  setExampleDetailInSidePaneOpen: (open: boolean) => void;
  isShowingDiff?: boolean;
  setIsShowingDiff?: (isShowingDiff: boolean) => void;
}) => {
  const handleDiffSwitchChange = () => setIsShowingDiff?.(!isShowingDiff);

  return (
    <>
      {children}
      <span className="flex-grow" />
      <div className="flex items-center gap-3">
        {setIsShowingDiff && (
          <div className="flex items-center gap-1">
            <span className="text-sm font-medium">Diff</span>

            <Switch
              size="sm"
              variant="soft"
              checked={isShowingDiff}
              onChange={handleDiffSwitchChange}
            />
          </div>
        )}
        {(dataset?.data_type === 'kv' || !dataset?.data_type) && (
          <div className="flex items-center">
            <ButtonGroup variant="outlined" color="secondary">
              <Tooltip
                title={
                  isShowingDiff
                    ? 'Diff is only supported for JSON and YAML'
                    : undefined
                }
              >
                <Button
                  onClick={() => setRowDetailLanguage('pretty')}
                  disabled={isShowingDiff}
                  color="secondary"
                  variant="outlined"
                  className={cn(
                    rowDetailLanguage === 'pretty' &&
                      !isShowingDiff &&
                      'hover:bg-brand-secondary-hover bg-brand-secondary'
                  )}
                >
                  Default
                </Button>
              </Tooltip>

              <Button
                onClick={() => setRowDetailLanguage('json')}
                className={cn(
                  rowDetailLanguage === 'json' &&
                    'hover:bg-brand-secondary-hover bg-brand-secondary'
                )}
              >
                JSON
              </Button>

              <Button
                onClick={() => setRowDetailLanguage('yaml')}
                className={cn(
                  rowDetailLanguage === 'yaml' &&
                    'hover:bg-brand-secondary-hover bg-brand-secondary'
                )}
              >
                YAML
              </Button>
            </ButtonGroup>
          </div>
        )}
        {dataset && (
          <Button
            variant="outlined"
            size="sm"
            color="secondary"
            rightDecorator={ArrowRightIcon}
            onClick={() => setExampleDetailInSidePaneOpen(true)}
          >
            Example
          </Button>
        )}
      </div>
    </>
  );
};
